/*
 * @Author: liyaoshi liyaoshi@sohu-inc.com
 * @Description: 常规文章页广告处理
 */
import Helper from "../../utils/helper"
import MptcfeWapAd from "mptcfe-wap-ad"
import Utils from "../../utils/util.js"
import adSspExposure from "../sspRequest/adExposure.js"
import { loadQuickAppScript } from '@/utils/loadScript.js'
// 智汇系列广告模板
import videoTxtAd from "../components/videoTxtAd.vue" // 视频广告
import bannerAd from "../../ad/components/bannerAd.vue" // 通栏广告
import { articleAdConfig } from "@/config/adConfig"
import { getOdinData } from "@/js/request/odinRequest"
import { getMiddleInsertBeforeDom } from "@/utils/element"

const AdGenerator = MptcfeWapAd.AdGenerator
if (Helper.urlToObj(location.href)["abSearch"] && window.AB_TEST) {
    window.AB_TEST.isSearchFeed = decodeURI(
        Helper.urlToObj(location.href)["abSearch"] || 1
    )
}
const isSearchFeed = window.AB_TEST && window.AB_TEST.isSearchFeed == 2
const borderTop = isSearchFeed ? "1px solid #f0f0f0" : "1px solid #e3e3e3"
const borderBottom = isSearchFeed ? "1px solid #f0f0f0" : ""

/**
 * @description 顶部通栏
 * @returns 
 */
export const topBannerAd = async function () {
    const adConfig = articleAdConfig.topBanner
    if(!adConfig) return
    const { resourceId, spmCCode, posCode, rule, fixArray } = adConfig
    const param = {
        resourceId,
        spmCCode,
        adInfo: {
            posCode,
            rule,
            fixArray,
        },
        isSingleAd: true,
    }
    try {
        const data = await getOdinData(param)
        const list = data?.list
        const adData = list?.[0]?.resourceData
        const adType = adData?.adType
        if(!adData) return
        const adComponentMap = {
            SOHUZH: {
                Banner: bannerAd,
            },
        }
        const adComponent = adComponentMap[adType] // 对象映射结构，由广告组件库根据具体的业务取template
        const topBillWrapper = document.querySelector(".top-bill-wrapper")
        const failCallback = function () {
            topBillWrapper.parentNode.removeChild(topBillWrapper)
        }
        new AdGenerator({
            data: adData,
            location: spmCCode,
            resourceId: resourceId,
            component: adComponent,
            isMulti: true, // 是否是复杂结构（广告template映射）
            success: function (adDom) {
                const isIframe = !!adDom.querySelector("iframe")
                const imageDom = adDom.querySelector("img")
                //添加SSP相关打码信息
                adDom = adSspExposure(adDom, adData)
                if (!isIframe && !!imageDom) {
                    const img = new Image()
                    img.onload = function () {
                        if (img.height > 100) {
                            topBillWrapper.className = "top-bill-wrapper"
                        }
                        topBillWrapper.innerHTML = ""
                        topBillWrapper.appendChild(adDom) // 必须通过appendChild的方式插入，否则获取不到元素尺寸，影响到iframe的宽高比计算和统计曝光
                    }
                    img.onerror = failCallback
                    img.src = imageDom.getAttribute("src")
                } else {
                    topBillWrapper.innerHTML = ""
                    topBillWrapper.appendChild(adDom)
                }
                //触发打码
                Utils.domDidChange({ target: "a-tb" })
            },
            successEmpty: failCallback,
            error: failCallback,
            timeout: failCallback,
        })
    } catch (error) {
        console.log("顶通广告渲染失败", error)
    }
}

/**
 * @description 中部文字链
 * @returns 
 */
export const middleTextAd = async function () {
    const adConfig = articleAdConfig.middleText
    const { resourceId, spmCCode, posCode, rule, fixArray } = adConfig
    const param = {
        resourceId,
        spmCCode,
        adInfo: {
            posCode,
            rule,
            fixArray,
        },
        isSingleAd: true,
    }
    try {
        const data = await getOdinData(param)
        const list = data?.list
        const adData = list?.[0]?.resourceData
        if(!adData) return
        new AdGenerator({
            data: adData,
            location: `${spmCCode}.1`,
            resourceId: resourceId,
            success: function (adDom) {
                //添加SSP相关打码信息
                adDom = adSspExposure(adDom, adData)
                //插入固定位置
                document.querySelector("#middleText").appendChild(adDom)
                //触发打码
                Utils.domDidChange({ target: "a-mt" })
            },
        })
    } catch (error) {
        console.log('中部文字链广告渲染失败', error)
    }
}

/**
 * @description 中部通栏广告
 */
export const middleBannerAd = async function () {
    const adConfig = articleAdConfig.middleBanner
    const { resourceId, spmCCode, posCode, rule, fixArray } = adConfig
    const param = {
        resourceId,
        spmCCode,
        adInfo: {
            posCode,
            rule,
            fixArray,
        },
        isSingleAd: true,
    }
    try {
        const data = await getOdinData(param)
        const list = data?.list
        const adData = list?.[0]?.resourceData
        if(!adData) return
        new AdGenerator({
            data: adData,
            location: `${spmCCode}.1`,
            resourceId: resourceId,
            containerId: "middleBanner",
            desParams: {
                containerStyle: {
                    padding: "12px 0",
                    "border-top": borderTop,
                    "border-bottom": borderBottom,
                },
            },
            success: function (adDom) {
                //添加SSP相关打码信息
                adDom = adSspExposure(adDom, adData)
                //插入固定位置
                if (adData) {
                    document.querySelector("#middleBanner").appendChild(adDom)
                    // TODO 当检测到广告的跳转链接是快应用时，增加appRouter的跳转方式，因为有一些机型不支持window.location.href的方式，后续考虑新增一种广告类型；
                    var isHap =
                        adData.adData &&
                        adData.adData.gotoUrl ==
                            "hap://app/com.sohu.mobile_quick/pages/tabbar?_trans_=000012_shwkyy_wapdztggw"
                    if (isHap) {
                        const fb = ()=> { 
                            $("#middleBanner").on("click", (e)=>{
                                appRouter(
                                    "com.sohu.mobile_quick",
                                    "pages/tabbar?_trans_=000011_shwkyy_vivokfwzx"
                                )
                            })
                        }
                        loadQuickAppScript(fb)
                    }
                }
                //触发打码
                Utils.domDidChange({ target: "a-mb" })
            }
        })
    } catch (error) {
        console.log('中部通栏广告渲染失败', error)
    }
}

/**
 * @description 看图模式中的组图底部广告（通栏、图混切换）
 * @returns 
 */
export const imgReadBottomAd = async function () {
    const adConfig = articleAdConfig.imageAd
    const { resourceId, spmCCode, posCode, rule, fixArray } = adConfig
    const param = {
        resourceId,
        spmCCode,
        adInfo: {
            posCode,
            rule,
            fixArray,
        },
        isSingleAd: true,
    }
    try {
        const data = await getOdinData(param)
        const list = data?.list
        const adData = list?.[0]?.resourceData
        if(!adData) return
        new AdGenerator({
            data: adData,
            location: spmCCode,
            resourceId: resourceId,
            success: function (adDom) {
                var billArea = document.querySelector(".bill-area")
                billArea.innerHTML = ""
                billArea.appendChild(adDom)
                //触发打码
                Utils.domDidChange({ target: "a-mb" })
            },
        })
    } catch (error) {
        console.log('看图模式组件底部广告', error)
    }
}

/**
 * @description 中插广告
 */
export const middleInsertAd = async function () {
    const adConfig = articleAdConfig.middleInsertAd
    const { resourceId, spmCCode, posCode, rule, fixArray } = adConfig
    const param = {
        resourceId,
        spmCCode,
        adInfo: {
            posCode,
            rule,
            fixArray,
        },
        isSingleAd: true,
    }
    try {
        const data = await getOdinData(param)
        const list = data?.list
        const adData = list?.[0]?.resourceData
        if(!adData) return
        let anAnchor = getMiddleInsertBeforeDom()
        new AdGenerator({
            data: adData,
            containerId: "middleInsertAd",
            params: {
                id: "middle",
            },
            location: spmCCode,
            resourceId: resourceId,
            isReportToSpm: true,
            success: function (adDom) {
                adDom = adSspExposure(adDom, adData)
                let adDomWrapper = document.createElement("div")
                adDomWrapper.className = "middle-mon-content"
                adDomWrapper.appendChild(adDom)
                //AB实验，isSearchFeed为2命中实验组，中插广告插在正文之后，有展开剩余时也可以出现
                if (window.AB_TEST && window.AB_TEST.isSearchFeed == 2) {
                    anAnchor = document.querySelector("#articleContent")
                }
                Helper.insertAfter(adDomWrapper, anAnchor)
                Utils.domDidChange({ target: "content" })
            },
            successEmpty: function () {
                var adDom = document.createElement("div")
                adDom.setAttribute("ad-empty", "middle_insert")
                Helper.insertAfter(adDom, anAnchor)
            },
            error: (error) => {
                console.log('中插广告异常', error)
            },
            timeout: () =>{
                console.log('中插广告超时')
            },
        })
    } catch (error) {
        console.log('中插广告渲染失败', error)
    }
}

/**
 * @description 文章末尾新广告位探索，新闻频道和要闻区进入
 * 广点通中插region也在这里
 * @returns 
 */
export const articleEndAd = async function () {
    const adConfig = articleAdConfig.middleInsertAd
    const { resourceId, spmCCode, posCode, rule, fixArray } = adConfig
    const param = {
        resourceId,
        spmCCode,
        adInfo: {
            posCode,
            rule,
            fixArray,
        },
        isSingleAd: true,
    }
    try {
        const data = await getOdinData(param)
        const list = data?.list
        const adData = list?.[0]?.resourceData
        if(!adData) return
        new AdGenerator({
            data: adData,
            location: spmCCode,
            resourceId: resourceId,
            success: (adDom) => {
                document.querySelector("#articleContent").appendChild(adDom)
            },
        })
    } catch (error) {
        console.log('中插下移到文末的广告异常', error)
    }
}

/**
 * @description 底部广告（百度通栏/大图广告，位于网站地图上方）
 * @returns 
 */
export const bottomBannerAd = async function () {
    const adConfig = articleAdConfig.bottomBanner
    if(!adConfig) return
    const { resourceId, spmCCode, posCode, rule, fixArray } = adConfig
    const param = {
        resourceId,
        spmCCode,
        adInfo: {
            posCode,
            rule,
            fixArray,
        },
        isSingleAd: true,
    }
    try {
        const data = await getOdinData(param)
        const list = data?.list
        const adData = list?.[0]?.resourceData
        if(!adData) return
        //若为新品算广告，且超时时间未设置则设置为700ms
        if (adData.adType === MptcfeWapAd.AdType.XPS && !adData.adData.time) {
            adData.adData.time = 700
        }
        adData.adData && (adData.adData.lazy = false) // 去掉懒加载
        const creativeType = adData.adData?.creativeType
        const bottomBannerAdTemplate = {
            VideoTxt: videoTxtAd,
        }
        const component = bottomBannerAdTemplate[creativeType]
        new AdGenerator({
            data: adData,
            location: spmCCode,
            resourceId: resourceId,
            component: component,
            success: function (adDom) {
                //添加SSP相关打码信息
                adDom = adSspExposure(adDom, adData)
                //插入固定位置
                document.querySelector("#bottomBanner").appendChild(adDom)
                //触发打码
                Utils.domDidChange({ target: "b-mb" })
            },
        })
    } catch (error) {
        console.log('底部通栏广告异常', document.querySelector("#bottomBanner") ,error)
    }
}
